<template>
  <div class='h100vh-100'>
    <ReportGnbDataMenu ref="reportGnbDataMenuRef"></ReportGnbDataMenu>
    <ReportGnbTaskList ref="reportGnbTaskListRef" @getDataByTaskId="getDataByTaskId" :dataLength="dataLength"></ReportGnbTaskList>
  </div>
</template>

<script>
  import ReportGnbDataMenu from "./ReportGnbDataMenu";
  import ReportGnbTaskList from "./ReportGnbTaskList";
  import {EventBus} from "../../../../../plugins/eventBus";
  export default {
    name: 'PmReportGnbDataRightList',
    components: {
      ReportGnbDataMenu,
      ReportGnbTaskList,
    },
    data() {
      return {
        dataLength: 0,
      };
    },
    methods: {
      getDataByTaskId(param){
        console.log('param',param);

        const counters=JSON.parse(param.counterList);
        const customCounters=JSON.parse(param.customCounterList);

        let countersList=[];
        let customCountersList=[];

        let idCountersList=[];
        let idCustomCountersList=[];

        for(var key in counters){
          if (counters.hasOwnProperty(key)) {
            let counterMap={id:'',text:''};
            counterMap.id=key;
            counterMap.text=counters[key];
            countersList.push(counterMap);
            idCountersList.push(key);
          }
        }

        for(var key in customCounters){
          if (customCounters.hasOwnProperty(key)) {
            let customCounterMap={id:'',text:''};
            customCounterMap.id=key;
            customCounterMap.text=customCounters[key];
            customCountersList.push(customCounterMap);
            idCustomCountersList.push(key);
          }
        }

        console.log("countersList",countersList);
        console.log("customCountersList",customCountersList);

        this.$refs.reportGnbTaskListRef.getColumnsOfGnbPmDataQuery(countersList, customCountersList);//动态生成表头
        this.dataLength = countersList.length + customCountersList.length;
        this.$refs.reportGnbTaskListRef.$refs.reportGnbTaskDataRef.refreshColumns();
        this.$axios.post('/lte/ems/pm/gnb/query/getReportGnbData',
          {
          startTime: param.startTime == null || param.startTime == 0 ? null : new Date(param.startTime).Format("yyyy-MM-ddTHH:mm:ss"),
          endTime: param.endTime == null || param.endTime == 0 ? null : new Date(param.endTime).Format("yyyy-MM-ddTHH:mm:ss"),
          checkSystemNodeIdList: idCountersList,
          checkCustomNodeIdList: idCustomCountersList,
          exeTime: param.exeTime == null || param.exeTime == 0 ? null : new Date(param.exeTime).Format("yyyy-MM-ddTHH:mm:ss"),
          spaceCode: param.space,
          paramTypeCode: param.parameterType,
          page: {
            pageNo: 1,
            pageSize: 18
          }}
        ).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.$refs.reportGnbTaskListRef.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.reportGnbTaskListRef.page.currentPage = response.data.resultVal.pageNo;
          } else {
            this.$refs.reportGnbTaskListRef.page.totalRecordsCount = 0;
            this.$refs.reportGnbTaskListRef.page.currentPage = 1;
          }
          this.$refs.reportGnbTaskListRef.reportDataSource = result;

        })
      },
      methodList(operator) {
        switch (operator) {
          case 'export':
            this.$refs.reportGnbTaskListRef.exportReportGnbListData();
            break;
          case 'statistics':
          this.$refs.reportGnbTaskListRef.chartOfReportShow();
            break;
          default:
        }
      },

    },
  };
</script>

<style>
</style>
